/* eslint-disable no-underscore-dangle */
import React from 'react'

import { ExpandableCell } from './ExpandableCell'

export type SectorCellProps = {
  cellProps: {
    original: {
      sectors: SectorItemProps[]
    }
  }
}

export type SectorItemProps = {
  name: string
}

export const sectorFilter = (filterItem: any, data: any) => {
  const filter = filterItem.value.toLowerCase()
  const { sectors } = data._original
  const sectorNames = sectors.map((sector: SectorItemProps) =>
    sector.name.toLowerCase()
  )
  let result = false
  if (
    sectorNames.length &&
    sectorNames.some((sector: any) => sector.includes(filter))
  )
    result = true
  return result
}

export const SectorCell = ({
  cellProps: {
    original: { sectors }
  }
}: SectorCellProps) => {
  if (!sectors) return null
  const sectorNames = sectors.map(({ name }) => name)
  return <ExpandableCell defaultLength={4} items={sectorNames} />
}
